export default "__VITE_PUBLIC_ASSET__9c38d923__"